import React, { FC } from 'react';
import { getImageUrl } from '../../../../utils/navigation';

interface PromoBannerProps {
  staticBanner: {
    thumbnail?: { filename_disk?: string | null; title?: string | null } | null;
    translations?: Array<{ link_URL?: string | null; open_in_new_tab?: boolean | null } | null> | null;
  };
}

export const PromoBanner: FC<PromoBannerProps> = ({ staticBanner }) => {
  const bannerUrl = staticBanner.thumbnail?.filename_disk ? getImageUrl(staticBanner.thumbnail.filename_disk) : null;

  if (!bannerUrl) return null;

  const bannerAlt = staticBanner.thumbnail?.title || 'Promotional banner';
  const bannerTranslation = staticBanner.translations?.[0];
  const bannerLink = bannerTranslation?.link_URL;
  const bannerOpenInNewTab = bannerTranslation?.open_in_new_tab;

  const handleClick = (): void => {
    if (!bannerLink) return;
    window.open(bannerLink, bannerOpenInNewTab ? '_blank' : '_top');
  };

  return (
    <div
      className="mini-games-top__banner"
      onClick={handleClick}
      style={{ cursor: bannerLink ? 'pointer' : 'default' }}
    >
      <img src={bannerUrl} alt={bannerAlt} />
    </div>
  );
};
